(function () {
  if (window.__mx) return;
  window.__mx = true;
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('mx-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  function scan() {
    var els = document.querySelectorAll('.mx-reveal:not(.is-in)');
    var i = 0;
    els.forEach(function (el) {
      el.style.transitionDelay = (Math.min(i++, 6) * 60) + 'ms';
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  /* Sicherheitsnetz: nach 4 s alles sichtbar machen */
  setTimeout(function () { document.querySelectorAll('.mx-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
})();
